module.exports = __webpack_public_path__ + "media/wrongGuess.f897b485.wav";